import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { LayoutService } from 'src/app/core/services/layout.service';

@Component({
    selector: 'app-theme-toggle',
    templateUrl: './theme-toggle.component.html',
    imports: [CommonModule, ButtonModule]
})
export class ThemeToggleComponent {
  constructor(public layoutService: LayoutService) {}

  ngOnInit() {}
}
